import styled from 'styled-components';
import { themeColorWithOpacity, themeColor } from '../../../theme/getters';

export const Container = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid ${themeColorWithOpacity('border', 0.2)};
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
`;
export const Title = styled.span`
  font-size: 18px;
  line-height: 24px;
  flex: 1;
  margin-right: 10px;
  color: ${themeColor('primary')};
`;
export const Description = styled.span`
  display: block;
  font-size: 16px;
  line-height: 21px;
  color: ${themeColor('border')};
  margin-top: 5px;
`;
